import * as actionTypes from "../actionTypes";

export const receivedUniversalLink = eventData => ({type: actionTypes.APP_RECEIVED_UNIVERSAL_LINK, data: eventData});
export const receivedPause = () => ({type: actionTypes.APP_RECEIVED_PAUSE});
export const receivedResume = () => ({type: actionTypes.APP_RECEIVED_RESUME});
export const receivedBackButton = () => ({type: actionTypes.APP_RECEIVED_BACK_BUTTON});
export const receivedMenuButton = () => ({type: actionTypes.APP_RECEIVED_MENU_BUTTON});
export const receivedSearchButton = () => ({type: actionTypes.APP_RECEIVED_SEARCH_BUTTON});
export const unloadEverything = () => ({type: actionTypes.APP_UNLOAD_EVERYTHING});